import 'select2';
export default () => {
    (($) => {
        $(document).ready(function(){
            paginationScroll();
            console.log($("#select-type"));
        });
        $("#select-type").select2({
            allowClear: false,
        }).on('change', function (e) {
            $(this).on('select2:select', function (e) {
                var data = e.params.data;
                var selectElement = $('<select>').attr('name', 'select_name').attr('style', 'display: none; height:0px;');
                $('<option>').val('369').text('').attr('style', 'display: none; height:0px;').appendTo(selectElement);
                selectElement.appendTo('#projects-search-form');
                $('#projects-search-form').submit();
            });
        });

    })(jQuery);
}

function paginationScroll() {
    var currentPage = document.getElementById('currentPage');
    if (currentPage) {
        var page = currentPage.dataset.current;
        var element =  document.querySelector(`[data-page="${page}"]`);

        if (element && page != 1) {
            var headerOffset = 125;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition
            });
        }
    }
}
